export default __webpack_public_path__ + "static/media/p5-5.3e16eb24.png";